import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ServiceHero = () => {
  const handleEmergencyCall = () => {
    window.location.href = 'tel:0827935785';
  };

  return (
    <section className="relative bg-gradient-to-br from-primary via-secondary to-primary text-primary-foreground py-16 md:py-24 lg:py-32 overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-32 h-32 md:w-48 md:h-48 lg:w-64 lg:h-64 border-4 border-accent rounded-full"></div>
        <div className="absolute bottom-10 right-10 w-24 h-24 md:w-36 md:h-36 lg:w-48 lg:h-48 border-4 border-accent rounded-full"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div>
            <div className="inline-flex items-center gap-2 bg-accent text-accent-foreground px-4 py-2 rounded-full mb-4 md:mb-6">
              <Icon name="Zap" size={20} />
              <span className="font-accent text-sm md:text-base">24/7 Emergency Response</span>
            </div>

            <h1 className="font-headline font-bold text-3xl md:text-4xl lg:text-5xl mb-4 md:mb-6">
              Expert Electrical Services You Can Trust
            </h1>

            <p className="font-body text-base md:text-lg lg:text-xl opacity-90 mb-6 md:mb-8">
              30+ years of electrical expertise. From emergency fault finding to complete installations, we deliver safe, reliable solutions for homes and businesses across South Africa.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <Button
                variant="default"
                size="lg"
                onClick={handleEmergencyCall}
                iconName="Phone"
                iconPosition="left"
                className="bg-accent hover:bg-accent/90 text-accent-foreground emergency-cta">

                Emergency: 082 793 5785
              </Button>
              <Button
                variant="outline"
                size="lg"
                iconName="FileText"
                iconPosition="left"
                className="bg-primary-foreground text-primary hover:bg-primary-foreground/90">

                Request Quote
              </Button>
            </div>

            <div className="grid grid-cols-3 gap-4 mt-8 md:mt-12">
              <div className="text-center">
                <div className="font-headline font-bold text-2xl md:text-3xl lg:text-4xl text-accent">30+</div>
                <div className="font-body text-xs md:text-sm opacity-80">Years Experience</div>
              </div>
              <div className="text-center">
                <div className="font-headline font-bold text-2xl md:text-3xl lg:text-4xl text-accent">24/7</div>
                <div className="font-body text-xs md:text-sm opacity-80">Emergency Service</div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden shadow-elevated">
              <img
                src="https://images.unsplash.com/photo-1615774925655-a0e97fc85c14"
                alt="Professional electrician in safety gear working on electrical panel with testing equipment in modern residential setting"
                className="w-full h-full object-cover" />

            </div>
            <div className="absolute -bottom-4 -right-4 bg-card text-foreground p-4 md:p-6 rounded-xl shadow-elevated max-w-xs">
              <div className="flex items-center gap-3 mb-2">
                <div className="bg-success/10 p-2 rounded-lg">
                  <Icon name="Shield" size={24} color="var(--color-success)" />
                </div>
                <div>
                  <div className="font-headline font-semibold text-sm md:text-base">Safety First</div>
                  <div className="font-body text-xs text-muted-foreground">Certified & Compliant</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default ServiceHero;